export const getFullLevelString = (level) =>
  `${level.title.id.replaceAll('_', '').toUpperCase()} - ${level.title.name}`;
